import {configureStore} from '@reduxjs/toolkit';
import {dataLayerMiddleware} from '~/CreateFabricGreetingCard/middleware/dataLayerMiddleware';
import {previewTransformMiddleware} from '~/CreateFabricGreetingCard/middleware/previewTransform';
import {api as eventApi} from '~/CreateFabricInvitation/api/api';
import {api as checkoutApi} from '~/common/checkout/api/api';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';
import {guestsLegacyActionMapper} from '~/common/fabric/EventGuests/reducers/guests/legacy-reducer';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {rootReducer} from './reducers';

const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(
    eventApi.middleware,
    guestsApi.middleware,
    checkoutApi.middleware,
    dataLayerMiddleware,
    promiseResolverMiddleware,
    previewTransformMiddleware,
    guestsLegacyActionMapper
  );

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {},
  middleware: middlewares,
});
